import { Link } from "wouter";
import { FaArrowRight } from "react-icons/fa";
import { ServiceType } from "@/data/services";

interface ServiceCardProps {
  service: ServiceType;
}

const ServiceCard = ({ service }: ServiceCardProps) => {
  return (
    <div className="service-card bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300">
      <div className="h-48 overflow-hidden">
        <img 
          src={service.image} 
          alt={service.title} 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-heading font-bold text-primary mb-3">
          {service.title}
        </h3>
        <p className="text-gray-700 mb-4">
          {service.description}
        </p>
        <Link href="/contact" className="text-[#D95204] font-bold hover:underline flex items-center">
          <span>Поискайте оферта</span>
          <FaArrowRight className="ml-2" />
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
